export enum BookingStepEnum {
  Init = 0,
  SelectBookingPacks = 10,
  SelectBookingEventsPacks = 11,
  SelectBookingSlots = 20,
  SelectNearestBookingSingleProducts = 25,
  SelectBookingSingleProducts = 30,
  SelectBookingEventAreaItemSlots = 35,
  SelectBookingEventProducts = 40,
  SelectBookingExtraProducts = 50,
  ShowOrder = 60,
  Authentication = 65,
  Login = 70,
  Register = 80,
  RegisterAsGuest = 90,
  Payment = 100,
  GroupEvent = 110,
  GroupEventThankYou = 120,
  Reset = 130,
  ShowProductConfigurationPage = 140,
}
